import React, { useEffect } from 'react';
import Home from './components/Home';
import Tunesien from './components/Tunesien';
import Startseite from './components/Startseite';
import Dienstleistung from './components/Diensleistung';
import Kontakt from './components/Kontakt';
import Team from './components/Team';
import VisionMission from './components/VisionMission';
import Ueberuns from './components/Ueber-uns';
import Referenzen from './components/Referenzen';
import Datenschutz from './components/Datenschutz';
import Footer from './components/layout/footer';
import Header from './components/layout/header';

import { BrowserRouter as Router, Route, Switch, useLocation } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import './style/global.css';

const PageTitle = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const titles = {
      "/": "Medway Recruitment",
      "/Startseite": "Startseite | Medway Recruitment",
      "/Dienstleistung": "Leistungen | Medway Recruitment",
      "/Tunesien": "Tunesien | Medway Recruitment",
      "/Kontakt": "Kontakt | Medway Recruitment",
      "/Team": "Team | Medway Recruitment",
      "/Vision-Mission": "Vision & Mission | Medway Recruitment",
      "/Ueber-uns": "Ueber uns | Medway Recruitment",
      "/Referenzen": "Referenzen | Medway Recruitment",
      "/Datenschutz": "Datenschutz | Medway Recruitment",
    };

    document.title = titles[pathname] || "Medway Recruitment";
  }, [pathname]);

  return null;
};

const App = () => {
  return (
    <div className="App">
      <Router>
        <PageTitle />
        <Header />
        <Switch>
          <Route exact path="/">
            <Home />
          </Route>
          <Route path="/Tunesien">
            <Tunesien />
          </Route>
          <Route path="/Startseite">
            <Startseite />
          </Route>
          <Route path="/Dienstleistung">
            <Dienstleistung/>
          </Route>
          <Route path="/Kontakt">
            <Kontakt />
          </Route>
          <Route path="/Team">
            <Team />
          </Route>
          <Route path="/Vision-Mission">
            <VisionMission />
          </Route>
          <Route path="/Ueber-uns">
            <Ueberuns />
          </Route>
          <Route path="/Referenzen">
            <Referenzen />
          </Route>
          <Route path="/Datenschutz">
            <Datenschutz />
          </Route>
        </Switch>
      </Router>
      <Footer />
    </div>
  );
};

export default App;
